import NewTable from "ui/components/NewTable";
import { EntradaAcordo } from "core/features/acordo/typings";
import useListagemEntradaAcordoColumns from "../../hooks/useListagemEntradaAcordoColumns";

function TabelaAcordoEntrada({
  isLoading,
  data,
}: {
  data: EntradaAcordo;
  isLoading: boolean;
}) {
  const columns = useListagemEntradaAcordoColumns();

  return (
    <>
      <NewTable<EntradaAcordo>
        loading={isLoading}
        columns={columns}
        dataSource={data ? [data] : []}
        pagination={false}
      />
    </>
  );
}

export default TabelaAcordoEntrada;
